import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    // boxShadow: 'none'
  }
}));

type Props = {
  className?: string,
}

const Topbar = (props: Props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
    >
      <Toolbar>
        <RouterLink to="/" />
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
